const selectSelfGuidedTour = (state) => state.selfGuidedTour;
export const selectSpecId = (state) => selectSelfGuidedTour(state).specId;
export const selectModalStep = (state) => selectSelfGuidedTour(state).modalStep;
export const selectSelectedSlot = (state) => selectSelfGuidedTour(state).selectedSlot;
export const selectAdditionalHomes = (state) => selectSelfGuidedTour(state).additionalHomes;
export const selectVerificationMethod = (state) => selectSelfGuidedTour(state).verificationMethod;
export const selectQuestionResponses = (state) => selectSelfGuidedTour(state).questionsResponses;
export const selectBooking = (state) => selectSelfGuidedTour(state).booking;
export const selectBookingStatus = (state) => selectSelfGuidedTour(state).bookingStatus;
export const selectBookingError = (state) => selectSelfGuidedTour(state).bookingError;
export const selectTourableSpecs = (state) => selectSelfGuidedTour(state).tourableSpecs;